export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'multirx-theme';

export function getThemePreference(): ThemePreference {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  if (saved === 'system') return 'system';
  return document.documentElement.getAttribute('data-theme') === 'light' ||
    document.documentElement.getAttribute('data-theme') === 'dark'
    ? (document.documentElement.getAttribute('data-theme') as 'light' | 'dark')
    : 'system';
}

export function getEffectiveTheme(): 'light' | 'dark' {
  const pref = getThemePreference();
  if (pref === 'light') return 'light';
  if (pref === 'dark') return 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyThemePreference(pref: ThemePreference): void {
  localStorage.setItem(STORAGE_KEY, pref);
  if (pref === 'system') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', pref);
  }
  window.dispatchEvent(new CustomEvent('multirx-theme-change', { detail: { preference: pref } }));
}

export function readGameCanvasColor(): string {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--game-canvas-bg')
    .trim();
  return value || '#1e293b';
}

/** Écoute les changements OS quand le thème est « système » (plus de bouton nav dédié). */
export function initThemeToggleShortcut(): void {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getThemePreference() === 'system') {
      window.dispatchEvent(
        new CustomEvent('multirx-theme-change', { detail: { preference: 'system' } })
      );
    }
  });
}
